import { z } from 'zod';
import { esquemaConsultaPagina } from './comun.js';
/**
 * Contratos de la liquidación a proveedores.
 *
 * Del lado del equipo se acepta A QUIÉN y HASTA CUÁNDO, y nada más: qué líneas
 * entran y cuánto suman lo decide el servidor leyendo los costos que quedaron
 * congelados en cada línea al emitir la orden. Aceptar un monto sería aceptar
 * que alguien escriba cuánto le pagamos a un proveedor desde el navegador.
 */
export const ESTADOS_LIQUIDACION = ['pendiente', 'aprobada', 'pagada', 'anulada'];
/** Cómo se le nombra cada estado a una persona. */
export const ETIQUETA_ESTADO_LIQUIDACION = {
    pendiente: 'por aprobar',
    aprobada: 'aprobada, por pagar',
    pagada: 'pagada',
    anulada: 'anulada',
};
export const esquemaCrearLiquidacion = z
    .object({
    proveedorId: z.string({ required_error: 'Falta el proveedor' }).min(1, 'Falta el proveedor'),
    /**
     * Corte de entregas. Ausente significa «todo lo entregado hasta hoy», que es
     * lo que se quiere el 95 % de las veces.
     */
    hasta: z
        .string()
        .datetime({ offset: true, message: 'La fecha de corte no es válida' })
        .optional(),
})
    .strict();
/**
 * Cambio de estado.
 *
 * Los tres campos condicionales los vuelve a exigir el servidor según el estado
 * destino —motivo para anular, referencia para pagar, motivo del ajuste si hay
 * ajuste—. Acá van opcionales porque un `refine` por combinación produciría
 * mensajes peores que los del servidor, que sabe además el estado ACTUAL.
 */
export const esquemaCambiarLiquidacion = z
    .object({
    estado: z.enum(ESTADOS_LIQUIDACION),
    /** Obligatorio para anular. */
    motivo: z.string().trim().max(500).optional(),
    /** Obligatorio para marcar pagada: el número de la transferencia. */
    referenciaPago: z.string().trim().max(120).optional(),
    /**
     * Ajuste sobre el total aprobado, positivo o negativo.
     *
     * Es la ÚNICA forma de corregir una liquidación aprobada: editar el total
     * borraría el rastro de qué se aprobó y qué se cambió después, que es
     * justamente lo que hay que poder mostrarle al proveedor que reclama.
     */
    ajusteMonto: z
        .number({ invalid_type_error: 'El ajuste debe ser un número' })
        .int('El ajuste debe ser un entero')
        .min(-99_999_999)
        .max(99_999_999)
        .optional(),
    ajusteMotivo: z.string().trim().max(500).optional(),
})
    .strict();
export const esquemaConsultaLiquidaciones = esquemaConsultaPagina.extend({
    estado: z.enum(ESTADOS_LIQUIDACION).optional(),
    proveedorId: z.string().min(1).optional(),
    /** Solo las que vencen en los próximos N días. Es la vista «qué pago esta semana». */
    venceEnDias: z.coerce.number().int().min(0).max(365).optional(),
});
//# sourceMappingURL=liquidaciones.js.map